import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableBeneficiaries } from '../../components';
import ErrorTeam from '../../components/ErrorTeam';
import { useBeneficiaries } from '../../contexts/Beneficiaries';

const Beneficiaries = () => {
  const { t } = useTranslation(['beneficiaries', 'errorNoTeam']);

  const { isEmpty, loading, isEmptySearch } = useBeneficiaries();

  const hasSearchAndEmptyList = !isEmptySearch && isEmpty;

  const errorType = hasSearchAndEmptyList ? 'errorNoSearch' : 'errorNoTeam';

  return (
    <div className="w-100 main-page-container" data-testid="main-page-test-id">
      <div className="w-100 beneficiaries-body-container" id="front-page">
        <TableBeneficiaries />
      </div>
      {isEmpty && !loading && (
        <ErrorTeam
          isSearchError={hasSearchAndEmptyList}
          title={t('title', { ns: errorType })}
          description={t('description', { ns: errorType })}
        />
      )}
    </div>
  );
};

export default Beneficiaries;
